import { render, staticRenderFns } from "./FichesTable.vue?vue&type=template&id=47ef3ad3&scoped=true"
import script from "./FichesTable.vue?vue&type=script&lang=js"
export * from "./FichesTable.vue?vue&type=script&lang=js"
import style0 from "./FichesTable.vue?vue&type=style&index=0&id=47ef3ad3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef3ad3",
  null
  
)

export default component.exports